import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ThuHoach, IThuHoach} from '@entities/canh-tac/hanh-dong.model';
import {ThuHoachService} from '@entities/thu-hoach/thu-hoach.service';
import {HttpResponse} from '@angular/common/http';
import {LocalStorageService} from 'ngx-webstorage';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-chi-tiet-thu-hoach',
  templateUrl: './chi-tiet-thu-hoach.component.html',
})
export class ChiTietThuHoachComponent implements OnInit {
  objectData: any;
  action: any;
  loId: any;
  constructor(
    private activatedRoute: ActivatedRoute,
    private thuHoachService: ThuHoachService,
    private localStorage: LocalStorageService,
    private titleService: Title,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    const id = this.activatedRoute.snapshot.paramMap.get('id');
    setTimeout(() => {
      this.loadHanhDong(id);
    }, 10);
  }
  loadHanhDong(id: any) {
    this.titleService.setTitle(
      this.translate.instant(
        'entities.thu-hoach.chi-tiet-thu-hoach.Thu Hoạch_title',
      ),
    );
    this.thuHoachService.find(id).subscribe(
      (res: HttpResponse<IThuHoach>) => {
        res.body.activityTypeId = 10;
        res.body.titlePage = this.translate.instant(
          'entities.thu-hoach.chi-tiet-thu-hoach.Thu Hoạch_title',
        );
        this.onSuccess(res.body);
      },
      (res: HttpResponse<any>) => this.onError(),
    );
  }

  private onSuccess(data: any) {
    this.objectData = data;
  }

  private onError() {
    this.objectData = new ThuHoach();
  }
}
